import { render, staticRenderFns } from "./PrintCodigo.vue?vue&type=template&id=07c59069&"
import script from "./PrintCodigo.vue?vue&type=script&lang=js&"
export * from "./PrintCodigo.vue?vue&type=script&lang=js&"
import style0 from "./PrintCodigo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VCard,VChip})
